var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "model-comparison" },
    [
      _c("loading-element", {
        staticClass: "continue-button__spinner",
        attrs: {
          "z-index": 2,
          "is-loading": _vm.isLoading,
          "bg-color": "rgb(255, 255, 255)",
          center: "",
          absolute: "",
        },
      }),
      _vm._v(" "),
      _vm.products.length === 0 ? _vm._t("empty") : _vm._e(),
      _vm._v(" "),
      _vm._l(this.products, function (item, index) {
        return _c("ComparisonItem", {
          key: index,
          attrs: { data: item.data.product },
          on: {
            "delete-item": function ($event) {
              return _vm.deleteItem(item.data.product.shopProductId)
            },
          },
          scopedSlots: _vm._u(
            [
              {
                key: "button-label",
                fn: function () {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "btn-primary",
                        attrs: {
                          href: _vm.addUmbrellaToDealerUrl(
                            item.data.product.sku
                          ),
                        },
                      },
                      [_vm._v(_vm._s(_vm.t("compare.buttonaction")))]
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }